import { useEffect } from 'react';

function useUnmountEffect(callback, deps = []) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => callback, deps);
}

export default useUnmountEffect;
